import React, { useContext } from 'react';
import * as styles from './index.module.less';
import { AccountMembers, AccountPersonal } from 'notta-web-icon';
import { GOODS_TYPE } from '@/modules/pricing/utils';
import { PricingContext } from '@/modules/pricing-v2/provider';
import NumberStepper from '@/modules/pricing/components/stepper/NumberStepper';

interface ICardSeatsDuration {
  seatsDesc: string;
  durationDesc:
    | string
    | {
        text: string;
        tooltip: {
          toolTipText: string;
          toolTipImg: null | {
            en: any;
            jp: any;
          };
        };
      };
  index: number;
  type: GOODS_TYPE;
}

const CardSeatsDuration = ({ seatsDesc, index, type }: ICardSeatsDuration) => {
  const { formInfo, dispatchFormInfo } = useContext(PricingContext);

  return (
    <div
      style={{
        gridArea: `s${index}`,
      }}
      className={styles.card_seats_duration_wrapper}
    >
      <div className={styles.seat_part}>
        {[GOODS_TYPE.TEAM, GOODS_TYPE.TEAM_ENTERPRISE].includes(type) ? (
          <AccountMembers className={styles.deco_icon} />
        ) : (
          <AccountPersonal className={styles.deco_icon} />
        )}
        <div className={styles.seat_desc}>
          {type === GOODS_TYPE.TEAM && (
            <NumberStepper
              minimum={1}
              maximum={50}
              defaultValue={formInfo.seats}
              onChange={(value) => {
                dispatchFormInfo({
                  type: 'seats',
                  value,
                });
              }}
            />
          )}
          {seatsDesc}
        </div>
      </div>
      {/* <div className={styles.duration_part}>
        <RecordsVoiceprint className={styles.deco_icon} />
        <div className={styles.duration_desc}>
          {type === GOODS_TYPE.TEAM && (
            <Select
              value={formInfo.duration}
              options={selectOptions}
              onChange={(value) => {
                dispatchFormInfo({
                  type: 'duration',
                  value,
                });
              }}
            />
          )}
          {typeof durationDesc !== 'string' ? (
            <>
              {t(durationDesc.text)}
              <Tooltip
                overlayClassName={`${styles.tooltip} ${
                  durationDesc.tooltip?.toolTipText && !durationDesc.tooltip?.toolTipImg && styles.only_title
                }`}
                title={
                  <TooltipContent title={durationDesc?.tooltip?.toolTipText && t(durationDesc?.tooltip?.toolTipText)} />
                }
              >
                <AccountHelpCenter className={styles.help_icon} />
              </Tooltip>
            </>
          ) : (
            durationDesc
          )}
        </div>
      </div> */}
    </div>
  );
};
export default CardSeatsDuration;
